<template>
  <BaseDialogTemplate
    v-model:open="openComputed"
  >
    <template v-slot:title>お知らせの詳細</template>

    <div class="d-flex justify-center">
      <v-container>
        <v-row v-if="data.title">
          <v-col cols="12">
          <p class="dialog-heading">
            {{ data.title }}
          </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-end">
            <p class="">
              公開日：{{ formatDate(data.publishedAt) || formatDate(data.createdAt) }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p style="white-space: pre-line;">{{ data.message }}</p>
          </v-col>
        </v-row>
        <v-row class="mt-7">
          <v-col class="d-flex justify-center">
            <Button
              styling="Flat"
              type="submit"
              @click="cancelDialog"
              >
              閉じる</Button>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- closeボタン -->
    <template v-slot:actions>
      <v-btn
      variant="text"
      @click="cancelDialog"
      icon="mdi-close"
      size="30"
    >
  </v-btn></template>
  </BaseDialogTemplate>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue';
import { useFormatFunc } from '@/utils/formatter';
import BaseDialogTemplate from '@/components/templates/BaseDialogTemplate.vue'
import Button from '@/components/molecules/buttons/Button.vue';

// Emits ------------------
interface Emits {
  (e: 'update:open', open: boolean): void,
  (e: 'success', loginId: any): void,
  (e: 'cancel'): void,
}
const emits = defineEmits<Emits>();

// Props ------------------
interface Props {
  open: boolean,
  data: any,
}
const props = withDefaults(defineProps<Props>(), {
  open: false,
});

// open ------------------
const { open } = toRefs(props)
const openComputed = computed({
  get: () => open.value,
  set: (value) => {
    emits('update:open', value)
  }
})

// キャンセル
const cancelDialog = () => {
  emits('cancel')
}

/**
 * 日付をフォーマットします
 * @param val
 */
 const formatDate = function (val: string): string {
  return useFormatFunc().formatDate(val, 'YYYY年MM月DD日')
}
</script>

<style lang="scss" scoped>
.input-header {
  font-size: 20px;
  font-weight: 700;
}

.dialog-heading {
  font-size: 24px;
  font-weight: 700;
}
</style>
